<template>
    <zen-one :showuserinfo="false" title="Sistem Hasil Bersepadu Kedah (iHasil)" :crumbs="crumbs">
         <z-page title="Kemaskini Resit">

          
            
                  
            <w-card bg-color="" class="">
                <w-flex justify-space-between class="mb4">
                  
                    <div class="xs10">
                    <w-input
                        v-model="cari.no_resit"
                        name="no_resit"
                        label="No Resit"
                        
                    />
                        <!-- <w-input v-model="cari.no_resit" label="No. Resit " />  -->
                </div>
                <div class="xs2">
                    <w-button class="ml1" v-on:click="reset()" :loading="cari.loading" bg-color="warning">
                        <w-icon>fal fa-redo-alt</w-icon>&nbsp;Reset
                    </w-button>
                    &nbsp;
                     <w-button class="ml1 " @click="detail()" :loading="cari.loading">
                        <w-icon>fal fa-search</w-icon>&nbsp;Cari
                    </w-button>
                </div>
                </w-flex>
                <br><br>


                 <z-page title="Resit Ibayaq">
                    <w-flex justify-center align-center class="mt5">
                        <div class="w-card__content content-hardcode">
                            <table class="table-dashboard" width="100%">
                                <thead>
                                    <tr>
                                        <td>Bil</td>
                                        <td>No. Resit</td>
                                        <td>Amaun (Rm)</td>
                                        <td></td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(dt, index) in ibayar">
                                    <!-- <tr> -->
                                        <td>{{(index+1)}}</td>
                                        <td>{{dt.no_resit}}</td>
                                        <td align="right">{{$zutil.currency(dt.amaun)}}</td>
                                        <td>
                                            <template v-if="ihasil.length == 0">
                                                <w-button class="ml1 " @click="jana()" :loading="cari.loading">
                                                    Jana Resit
                                                </w-button>
                                            </template>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </w-flex>
                </z-page>

                <z-page title="Resit iHasil">
                    <w-flex justify-center align-center class="mt5">
                        <div class="w-card__content content-hardcode">
                            <table class="table-dashboard" width="100%">
                                <thead>
                                    <tr>
                                        <td>Bil</td>
                                        <td>No. Resit</td>
                                        <td>Amaun (Rm)</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(dt, index) in ihasil">
                                    <!-- <tr> -->
                                        <td>{{(index+1)}}</td>
                                        <td>{{dt.no_resit}}</td>
                                        <td align="right">{{$zutil.currency(dt.amaun)}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </w-flex>
                </z-page>
            </w-card>
                   


        </z-page>
    </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZenOne from '@/Shared/ZenOne'
import ZResource from '@/Modules/z-resource-service'


export default {
  extends: ZResource,
  components: {
    // ZenOne
  },
  props: {
    items: [Array, Object],
  },
  data() {
    return {
        resourceurl: this.service_kutipan +'resit',
        loading : true,
        reload: true,
        resit_id : null,
        form_cari: {},
        cari : {
          loading: false,
        },
        ibayar : [],
        ihasil : [],
       
        crumbs: [
            // { label: this.$page.props.app_name, route: '/sitemap' },
            { label: 'iHasil', route: '/ihasil' },
            { label: 'Resit', route: '/resit' },
            { label: 'Kemaskini Resit', route: '/resit' }
          ],
          cari : { no_resit: ''},

          pilih : false
        }
         
  },
  methods: {

    

        detail() {
            
            // alert(this.cari.no_resit);
            // if(this.loading == false){
            //  this.loading = true
            //  this.$zcomm.get(this.service_kutipan +"cariresit" +"?no_resit=" +this.cari.no_resit)
            //     .then((res) => {
            //         console.log(res.data);
            //         this.loading = false
            //         this.cari.no_resit = null
            //         if(res.code == 1){
                        
                       
            //         }else{
            //         }

                 
            //     });
            this.ihasil = [];
            this.ibayar = [];
            this.$zcomm.get(this.service_kutipan +"resit/senarai_ibayaq" +"?no_resit=" +this.cari.no_resit)
                .then((res) => {
                    this.ihasil = res.data.items

                   
                 
                });

            this.$zcomm.get(this.service_ibayaq +"resit" +"?no_resit=" +this.cari.no_resit)
                .then((res) => {
                    this.ibayar = res.data.items

            }); 

           


                

            
        },

        reset(){
              this.cari = {no_resit: null}
              this.detail()
        },

        jana() {
            this.$zcomm.post(this.service_ibayaq +"jana_resit_ihasil", this.cari)
            .then((res) => {
                this.detail()

                this.$zcomm.get(this.service_kutipan +"resit/resit_ibayaq/" +this.cari.no_resit)
                .then((res) => {
                    this.resits = res
                    // alert(this.resits);

                    

                    if(this.resits == null ){
                        this.$zutil.message('Jana Resit iHASIL Tidak Berjaya', false);
                    }else{
                        this.$zutil.message('Jana Resit iHASIL Berjaya');
                    }

                 
                });


            })
            .finally(() => {

                this.loading = false
              });

        }

    


  },
  watch: {
     
  },
  mounted() {
    this.dialog.width = 900
    
  },
}
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>